import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { CSRF_TOKEN_API, CsrfTokenApi, validateReceivedToken } from 'components/ordering/csrf/csrf-token-api.js'
import { CSSResultGroup, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './csrf-token.style.js'


@customElement('csrf-token')
export class CsrfToken extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @inject(CSRF_TOKEN_API)
  private csrfTokenApi!: CsrfTokenApi

  override connectedCallback() {
    super.connectedCallback()
    this.replaceWithPlainInput()
  }

  private replaceWithPlainInput = async (): Promise<void> => {
    if (this.parentElement === null) return

    const token = await this.fetchCsrfToken()
    const parent = this.parentElement
    if (parent === null) return

    const input = document.createElement('input')

    input.name = '_csrf_token'
    input.value = token
    input.hidden = true

    parent.replaceChild(input, this)
  }

  private fetchCsrfToken = async (): Promise<string> => {
    const url = new URL('/xhr/csrf/', window.location.origin)
    const token = await this.csrfTokenApi.fetchCsrfToken(url)
    if (validateReceivedToken(token)) return token
    return ''
  }
}
